export default "__VITE_ASSET__BNyyzovG__"